/* 客户产品管理-API */

import {post,get} from '../../libs/ajax.js'

export default {
    // 账户列表
    getCompanyList:(data,options) => {
        return get('/customer_app_manage/get_company_list', data, options);
    },
    // 筛选条件-操作人下拉框列表
    getOperatorList:(data,options) => {
        return get('/customer_app_manage/get_operator_list', data, options);
    },
    // 获取未绑定客户数量
    getUnbindNum:(data,options) => {
        return get('/customer_app_manage/unbind_num', data, options);
    },
    // 获取客户绑定列表
    getCustomerAppList:(data,options) => {
        return get('/customer_app_manage/get_list', data, options);
    },
    // 未绑定客户产品LIST-产品搜索筛选下拉框数据
    postAppSelectList:(data,options) => {
        return post('/customer_app_manage/get_app_select_list', data, options);
    },
    // 获取未绑定客户列表
    getUnbindAppList:(data,options) => {
        return get('/customer_app_manage/unbind_app_list', data, options);
    },
    // 检查客户权限接口
    checkCustomer:(data,options) => {
        return get('/customer_app_manage/check_customer', data, options);
    },
    // 停用
    disableCustomerApp:(data,options) => {
        return post('/customer_app_manage/disable', data, options);
    },
    // 启用
    enableCustomerApp:(data,options) => {
        return post('/customer_app_manage/enable', data, options);
    },
    // 获取绑定客户options列表
    getCompanySelector:(data,options) => {
        return get('/customer_app_manage/get_company_selector', data, options);
    },
    // 未绑定产品-保存绑定
    saveUnbindApp:(data,options) => {
        return post('/customer_app_manage/unbind_app_save', data, options);
    },
    // 选择绑定产品 - 搜索产品
    getBindApp:(data,options) => {
        return get('/customer_app_manage/get_bind_app', data, options);
    },
    // 保存绑定
    bindAppSave:(data,options) => {
        return post('/customer_app_manage/bind_app_save', data, options);
    },
}
